import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { LoaderService } from './services/loader.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {
  constructor(router: Router, private loaderService: LoaderService) {
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // Hide progress spinner or progress bar
        if (event.url != '/pages/maintenance') {
          this.loaderService.isShoMmaintenance(false);
        }
      }
    });
  }

  ngOnInit() {

  }
}